import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectQueryKeys } from './constants'

export const useGetMyProjectsQuery = (
  search,
  expand = 'LastModified,Permissions',
  options
) => {
  const handleQuery = async () => {
    const config = {
      method: 'get',
      params: { fast: true, search, expand }
    }
    const { data } = await api(`/api/projects`, config)

    return data
  }

  return useQuery({
    queryKey: [projectQueryKeys.GET_MY_PROJECTS_QUERY, search, expand],
    queryFn: handleQuery,
    retry: 0,
    ...options
  })
}
